<template>
  <div class="blok-button" v-editable="blok" :style="wrapStyles">
    <a
      @click="trackButtonClick"
      :href="blok.link"
      :aria-label="blok.text"
      :class="linkClasses"
    >
      {{ blok.text }}
    </a>
  </div>
</template>

<script>
export default {
  props: ['blok'],
  computed: {
    wrapStyles() {
      return { 'text-align': this.blok.align }
    },
    linkClasses() {
      let appliedClasses = ''
      const styleClasses = {
        'main-button': 'cta-button',
        'medium-button': 'cta-button medium-button-dark',
        'low-button': 'cta-button low-button',
      }
      const sizeClasses = {
        small: 'cta-button-small',
        normal: '',
        wide: 'cta-button-wide',
      }
      const styleClassToApply = styleClasses[this.blok.style]
      if (styleClassToApply) {
        appliedClasses += styleClassToApply
      }
      const sizeClassToApply = sizeClasses[this.blok.size]
      if (sizeClassToApply) {
        appliedClasses = appliedClasses + ' ' + sizeClassToApply
      }
      return appliedClasses
    },
    userId() {
      return this.$store.state.user.currentUser.userId || 'guest'
    },
  },
  methods: {
    trackButtonClick() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'click-storyblok-button',
        eventLabel: 'UserID ' + this.userId,
      })
      this.$gtag.event('click-storyblok-button', {
        'event_category': 'Click',
        'event_label': 'UserID ' + this.userId,
      })
      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.blok-button a {
  margin: 10px;
  display: inline-block;
  white-space: nowrap;
  &:hover {
    text-decoration: none;
  }
}
.main-button {
  color: $btn-std-color;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  background: $btn-std-bg;
  padding: $btn-big-padding;
  border: 0px;
  border-radius: $btn-big-radius;
  font-size: $btn-big-text;
  font-weight: 400;
  min-width: $btn-big-width;
  &:hover {
    background: $btn-std-hover;
  }
}
.flat-button {
  background-color: transparent;
  color: #2196f3;
  transition: background-color 0.2s;
  border: none;
  border-radius: 2px;
  text-transform: uppercase;
  &:hover {
    text-decoration: none;
    background: #eef3f6;
  }
}
</style>
